import { daysUntilExpiry, formatSubscriptionDate, isSubscriptionExpired } from './academicYear';

export function getUniqueExpiryDates(heads) {
  const dates = new Set();
  for (const head of heads || []) {
    const exp = head.subscription_expires_at
      ? String(head.subscription_expires_at).slice(0, 10)
      : null;
    if (exp) dates.add(exp);
  }
  return [...dates].sort();
}

function matchesSearch(head, search) {
  if (!search) return true;
  const q = search.toLowerCase();
  return (
    head.name?.toLowerCase().includes(q) || head.username?.toLowerCase().includes(q)
  );
}

function matchesValidUntil(head, { validExact, validFrom, validTo, validPreset }) {
  const exp = head.subscription_expires_at
    ? String(head.subscription_expires_at).slice(0, 10)
    : null;

  if (validPreset === 'expired') {
    return Boolean(exp && isSubscriptionExpired(exp));
  }
  if (validPreset === 'expiring30') {
    if (!exp || isSubscriptionExpired(exp)) return false;
    const days = daysUntilExpiry(exp);
    return days !== null && days >= 0 && days <= 30;
  }
  if (validPreset === 'expiring14') {
    if (!exp || isSubscriptionExpired(exp)) return false;
    const days = daysUntilExpiry(exp);
    return days !== null && days >= 0 && days <= 14;
  }

  if (validExact) {
    return exp === validExact;
  }

  if (validFrom || validTo) {
    if (!exp) return false;
    if (validFrom && exp < validFrom) return false;
    if (validTo && exp > validTo) return false;
  }

  return true;
}

function sortByDivisions(list, divisionsSort) {
  if (divisionsSort === 'desc') {
    return [...list].sort(
      (a, b) => (parseInt(b.divisions, 10) || 0) - (parseInt(a.divisions, 10) || 0)
    );
  }
  if (divisionsSort === 'asc') {
    return [...list].sort(
      (a, b) => (parseInt(a.divisions, 10) || 0) - (parseInt(b.divisions, 10) || 0)
    );
  }
  return list;
}

export function applySchoolHeadFilters(
  heads,
  { search, validExact, validFrom, validTo, validPreset, divisionsSort }
) {
  let list = (heads || []).filter((head) => matchesSearch(head, search));
  list = list.filter((head) =>
    matchesValidUntil(head, { validExact, validFrom, validTo, validPreset })
  );
  return sortByDivisions(list, divisionsSort);
}

export function hasActiveSchoolFilters({
  validExact,
  validFrom,
  validTo,
  validPreset,
  divisionsSort,
}) {
  return Boolean(
    validExact ||
      validFrom ||
      validTo ||
      (validPreset && validPreset !== 'all') ||
      (divisionsSort && divisionsSort !== 'none')
  );
}

export function formatExpiryOption(isoDate) {
  return formatSubscriptionDate(isoDate);
}
